import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../styles/core.scss';
import css from './login-info.scss';
import LoginInfoDisplay from '../login-info-display/login-info-display';

/**
 * Login Information Component
 * Displays Total sign ins and time spent by a
 * student for a selected time period
 */
class LoginInfo extends Component {
    static propTypes = {
        logInInfo: PropTypes.shape({
            totalSignIns: PropTypes.number,
            totalTime: PropTypes.shape({
                hours: PropTypes.number,
                minutes: PropTypes.number
            })
        }),
        localeData: PropTypes.object
    };

    constructor(props) {
        super(props);
        const { logInInfo, localeData } = props;

        this.state = {
            loginInfo: [
                { title: localeData['Time  - SignIn'],
                    text: logInInfo.totalSignIns
                },
                {
                    title: localeData['Time  - Total'],
                    text: `${logInInfo.totalTime.hours}h  ${logInInfo.totalTime.minutes}min`
                }]
        };
    }

    render() {
        const { loginInfo } = this.state;

        return (
            <div className={css.component} >
                {loginInfo.map(info => (
                    <LoginInfoDisplay key={info.title} title={info.title} text={`${info.text}`} />
                ))}
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}


export default connect(mapStateToProps)(styleable(css)(LoginInfo));



// WEBPACK FOOTER //
// ./components/login-info/login-info.js